// extracted by mini-css-extract-plugin
module.exports = {"videoCallParticipantsChip":"video-call-participants-chip_videoCallParticipantsChip__S2pjA"};